import { AuthStoreManager } from "./auth-store-manager"
import { AuthVueRouterGuard } from "./auth-vue-router-guard"
import { AuthAxiosInterceptor } from './auth-axios-interceptor'
import { AuthHttp } from './auth-http'

export const DEFAULT_OPTIONS = {
    authMeta: 'auth',
    rolesVar: 'authorities',
    tokenDefaultName: 'default_auth_token',
    userDefaultName: 'default_auth_user',
    tokenStore: [
        'vuex',
        'localStorage',
        'sessionStorage'
    ],
    headerTokenReplace: '{auth_token}',
    tokenType: 'Bearer',
    vuexStoreSpace: 'vue-auth',

    authRedirect: '/auth/login',
    callback: null,
    loginAuth: null,

    requestTokenEndpoint: {
        url: '/auth/request',
        method: 'POST',
        redirect: '/',
        fetchUser: false,
    },
    loginEndpoint: {
        url: '/oauth/token',
        method: 'POST',
        redirect: '/',
        fetchUser: false,
    },
    checkTokenEndpoint: {
        url: '/auth/check_token',
        method: 'GET',
        redirect: '/',
        fetchUser: false,
    },
    fetchEndpoint: {
        url: '/auth/me',
        method: 'GET',
        interval: 30,
        enabled: false,
    },
    refreshEndpoint: {
        url: '/auth/refresh',
        method: 'GET',
        interval: 30,
        enabled: false,
    },
}

export class Auth {
    options = null

    axiosInterceptor = null
    storeManager = null
    router = null
    http = null

    constructor(Vue, options = {}) {
        this.options = { ...DEFAULT_OPTIONS, ...options }
        this.storeManager = new AuthStoreManager(Vue, this.options)
        this.router = new AuthVueRouterGuard(Vue, this.storeManager, this.options)
        this.axiosInterceptor = new AuthAxiosInterceptor(Vue, this.storeManager, this.options)
        this.http = new AuthHttp(Vue, this.options)

        if (this.options.callback) {
            this.options.callback()
        }

        this.refresh()
    }

    async refresh() {

      const to = window.location.pathname;
        if (typeof to != 'undefined' && (to.includes('/auth/login') || to.includes('/auth/authenticate'))) {
            this.storeManager.resetAll()
            // res.details = this.http.me()
            // this.storeManager.setUser(res)
        }
        else if (this.storeManager.getToken() != null) {
            let details = await this.http.me()

            if (details?.error) {
                this.storeManager.resetAll()
                this.options.router.push(this.options.authRedirect)
                return
            }

            let user = this.storeManager.getUser()

            if (user == null) {
                user = this.createUserFromResponses(null, details)
                this.storeManager.setUser(user)
            }
        }
    }

    createUserFromResponses(user, details) {
        let normalizedUser = user && !user.error ? user : {}

        normalizedUser.details = details

        if (normalizedUser[this.options.rolesVar] == null) {
            normalizedUser[this.options.rolesVar] = details?.[this.options.rolesVar] ?? details?.roles ?? []
        }

        return normalizedUser
    }

    async authenticate(jwt) {

        // Request auth token with temporary token
        let response = await this.http.requestAuthToken(jwt) // response.data.token
        let token = response?.data?.token

        if (token == null) {
            this.storeManager.resetAll()
            return false
        }

        // Set new token
        this.storeManager.resetAll()
        this.storeManager.setToken(token)
        let user = await this.http.checkToken(token)
        // Fetch user
        let details = await this.http.me()

        if (details?.error) {
            this.storeManager.resetAll()
            return false
        }

        user = this.createUserFromResponses(user, details)
        this.storeManager.setUser(user)
        this.options.router.push("/");
        return true
    }

    async login(username, password) {
        let response = await this.http.login(username, password)
        let token = response?.access_token

        if (token == null) {
            this.storeManager.resetAll()
            return false
        }

        this.storeManager.resetAll()
        this.storeManager.setToken(token)

        let user = await this.http.checkToken(token)
        let details = await this.http.me()

        if (details?.error) {
            this.storeManager.resetAll()
            return false
        }

        user = this.createUserFromResponses(user, details)
        this.storeManager.setUser(user)
        this.options.router.push("/");
        return true
    }

    logout() {
        this.reset()
    }

    reset() {
        this.storeManager.resetAll()
    }

    isAuthenticated() {
        return this.storeManager.getToken() != null && this.storeManager.getUser() != null;
    }

    isAuthorized(roles) {
        return this.storeManager.authorized(roles)
    }

    isAuthorizedByAttributes(attribute) {
      return this.storeManager.authorizedByAttribute(attribute)
    }

    me() {
        let user = this.storeManager.getUser()
        let details = null

        if (user == null) {
            details = this.http.me()
        } else {
            details = user.details
        }

        return details
    }
}
